import {
  LOGGED_IN,
  LOGGED_OUT,
  LOGIN_ERROR,
  UNAUTHORIZED
} from "../actions/auth";

const initialState = {
  loginAttempts: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGGED_IN:
      const { token, userID, LoginType } = action.payload;
      return {
        ...initialState,
        loggedIn: true,
        token,
        userID,
        LoginType,
        error: undefined
      };
    case LOGGED_OUT:
      return {
        ...initialState,
        loggedIn: false
      };
    case LOGIN_ERROR:
      return {
        ...initialState,
        error: action.payload
      };
    case UNAUTHORIZED:
      return {
        ...initialState,
        loginAttempts: state.loginAttempts + 1
      };
    default:
      return state;
  }
};
